import React, { useEffect, useRef, useState } from "react";
import { useClientesApi } from "./clientesApi";
import { errorDeApi } from "./clientesUtils";
import "../reservas/reservas-organizer.css";
import "./clientes.css";

/* "Fusionar" desde la lista: el personal elige cuál de las fichas seleccionadas queda (por defecto la de más turnos)
   y las demás se unen a ella. No se puede deshacer. `onListo(aviso, { recargar })` cierra y deja el aviso en la lista. */

const nombreDe = (c) => c.name || "Cliente sin nombre";
const turnosDe = (c) => Number(c.appointmentsCount) || 0;

// The first ficha with the most turnos (ties keep the list order).
const ganadoraPorDefecto = (fichas) => fichas.reduce((mejor, c) => (turnosDe(c) > turnosDe(mejor) ? c : mejor), fichas[0]);

const FusionarFichasModal = ({ fichas, onListo, onCerrar }) => {
  const api = useClientesApi();
  const [ganadora, setGanadora] = useState(() => ganadoraPorDefecto(fichas)._id);
  const [fusionando, setFusionando] = useState(false);
  const [error, setError] = useState("");
  const dialogRef = useRef(null);

  useEffect(() => {
    dialogRef.current?.focus();
  }, []);

  const fusionar = async () => {
    setFusionando(true);
    setError("");
    try {
      await api.merge(ganadora, fichas.filter((c) => c._id !== ganadora).map((c) => c._id));
      onListo("Fichas fusionadas.", { recargar: true });
    } catch (e) {
      const { message, codigo, status } = errorDeApi(e, "No pudimos fusionar las fichas. Probá de nuevo.");
      if (status === 403) {
        setError("No tenés permiso para fusionar fichas de cliente.");
      } else if (status === 404) {
        onListo("", { recargar: true, error: "Alguna de las fichas ya no está disponible. Actualizá la lista." });
        return;
      } else if (status === 409 && codigo === "dni_taken") {
        // Earlier sources may already be merged, so the list is stale.
        onListo("", { recargar: true, error: "Dos fichas tienen DNI distintos; no se pudieron fusionar todas. Revisá la lista." });
        return;
      } else {
        setError(message);
      }
      setFusionando(false);
    }
  };

  return (
    <div className="zr-overlay" onMouseDown={fusionando ? undefined : onCerrar}>
      <div
        className="zr-modal fc-modal-wide"
        role="dialog"
        aria-modal="true"
        aria-label="Fusionar fichas"
        ref={dialogRef}
        tabIndex={-1}
        onKeyDown={(e) => { if (e.key === "Escape" && !fusionando) { e.stopPropagation(); onCerrar(); } }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h3 className="zr-modal__title">Fusionar fichas</h3>
        <p className="zr-modal__text">
          Las demás se unen a la elegida: sus turnos, notas y cuentas pasan a esa ficha y los datos vacíos se completan. No se puede deshacer.
        </p>
        <fieldset className="fc-choose">
          <legend>¿Qué ficha queda?</legend>
          {fichas.map((c) => (
            <label key={c._id} className="fc-choose__option">
              <input type="radio" name="ficha-ganadora" checked={ganadora === c._id} disabled={fusionando} onChange={() => setGanadora(c._id)} />
              <span className="fc-row__name">{nombreDe(c)}</span>
              <span className="fc-row__sub">{c.phone || "Sin teléfono"}</span>
              <span className="fc-row__sub">{c.email || "Sin email"}</span>
              <span className="fc-row__meta">{turnosDe(c) === 1 ? "1 turno" : `${turnosDe(c)} turnos`}</span>
            </label>
          ))}
        </fieldset>
        {error && <div className="fc-error" role="alert">{error}</div>}
        <div className="zr-modal__actions">
          <button type="button" className="zr-btn zr-btn--ghost" disabled={fusionando} onClick={onCerrar}>Cancelar</button>
          <button type="button" className="zr-btn zr-btn--dark" disabled={fusionando} onClick={fusionar}>
            {fusionando ? "Fusionando…" : `Fusionar ${fichas.length} fichas`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FusionarFichasModal;
